import $ from 'jquery';
require('jquery-match-height/jquery.matchHeight.js');

var Search = {
    selectors: {
        search_results_dropdown: $('.search-results-dropdown'),
        search_input: $('#search'),
    },

    init: function () {
        this.fastSearchResultsHandler();
        this.filterResults();
        this.searchSubmit();
        this.toggleCategoriesResults();
        this.toggleBrandsResults();
    },

    searchProcess : false,
    hideResultsProcess : false,

    lastSearch : '',

    toggleCategoriesResults: function() {
        $('body').on('click', '.toggle-categories-search-results', function () {
            $('.search-results__categories').toggleClass('collapsed');
        });
    },

    toggleBrandsResults: function() {
        $('body').on('click', '.toggle-brands-search-results', function () {
            $('.search-results__brands').toggleClass('collapsed');
        })
    },

    fastSearchResultsHandler: function () {
        var selectors = this.selectors;
        $('body').on('input focus', '#search', function() {
            var value = $(this).val();

            if (value.length > 2) {
                if (this.searchProcess !== false) {
                    clearTimeout(this.searchProcess);
                    this.searchProcess = false;
                }
                if (selectors.search_input.val() == selectors.search_input.data('old-search')) return;
                if (selectors.search_input.val() == this.lastSearch) {
                    Search.showFastResults();
                } else {
                    this.lastSearch = selectors.search_input.val();
                    selectors.search_input.data('old-search', '');
                    this.searchProcess = setTimeout( function() {
                        $.ajax({
                            type: 'GET',
                            url: window.ajax.search.fastSearchUrl + '/' + selectors.search_input.val(),
                            error: function(resp) {
                                //Search.setFastResults(resp.responseJSON.message);
                                Search.hideFastResults();
                            },
                            success: function(data) {
                                Search.setFastResults(data.html);
                                Search.showFastResults();
                            }
                        });
                    }, 500);
                }
            } else {
                Search.setFastResults('');
                Search.hideFastResults();
            }
        }).on('focusout', function (){
            $(this).val('');
            if (Search.hideResultsProcess !== false) {
                clearTimeout(Search.hideResultsProcess);
                Search.hideResultsProcess = false;
            }
            Search.hideResultsProcess = setTimeout( function() {
                Search.hideFastResults();
            }, 200);
        })
    },

    setFastResults: function(data) {
        var selectors = this.selectors;
        selectors.search_results_dropdown.html(data);
    },

    showFastResults: function () {
        var selectors = this.selectors;
        selectors.search_results_dropdown.removeClass('d-none');
        $('.search-results-dropdown .products-item .products-item-inner-wrapper').matchHeight();
    },

    hideFastResults: function () {
        var selectors = this.selectors;
        selectors.search_results_dropdown.addClass('d-none');
    },

    filterResults: function () {
        $('body').on('click', '.search-filter-checkbox', function() {
            Search.submitFilter();
        });
        /*$('body').on('change', '#search-brand', function() {
            Search.submitFilter();
        });*/
        $('body').on('click', '.search-filter-category', function(e) {
            e.preventDefault();
            $('#search-form-category').val($(this).data('category-id'));
            Search.submitFilter();
        });
        $('body').on('click', '.search-filter-brand', function(e) {
            e.preventDefault();
            $('#search-form-brand').val($(this).data('brand-id'));
            Search.submitFilter();
        });
        $('body').on('change', '.search-results__products-filters-actions #products-per-page', function(e) {
            e.preventDefault();
            $('#search-form-per-page').val($('#products-per-page option:selected').val());
            Search.submitFilter();
        });
    },

    submitFilter: function () {
        if ($('#search-promo').is(':checked')) {
            $('#search-form-promo').val(1);
        } else {
            $('#search-form-promo').val(0);
        }
        if ($('#search-new').is(':checked')) {
            $('#search-form-new').val(1);
        } else {
            $('#search-form-new').val(0);
        }
        $('#search-form').submit();
    },

    searchSubmit: function () {
        $('body').on('click', '#search_submit', function() {
            $('#search-form-category').val('');
        });
    }

}

export default Search;
